import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["pageType"],
    _excluded2 = ["showDescription", "metaDescription", "showDate", "dateFormat", "publishedAt", "showLink", "linkText", "metaImage", "title", "url"],
    _excluded3 = ["showDescription", "metaDescription", "showDate", "dateFormat", "publishedAt", "showLink", "linkText", "metaImage", "title", "url"],
    _excluded4 = ["guide", "linkText", "showDate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint camelcase: ["error", {allow:["rate_table","^LEGACY__*","^UNSAFE_*"]}] */
import React from 'react';
import Card from '../card';
import { contentTypeId } from '@uswitch/ev-utils/contentful';
import { useEntity, useMeta } from '@uswitch/ev-utils/context/selectors';
import sw from '@uswitch/ev-utils/switch';
import dayjs from '@uswitch/ev-utils/date';
import loadable from '@loadable/component';
import { DynamicSparkIcon } from '../../elements/spark-icons/dynamic-spark-icon';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var SimpleCategoryGuideCard = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "simple-category-guide-card";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "simple-category-guide-card" */
    './simple-category-guide-card');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./simple-category-guide-card");
    }

    return eval('require.resolve')("./simple-category-guide-card");
  }
});
/** --- Legacy start
 * These page types are legacy contentful modules
 * that new pages still want to render and link to
 */

var LEGACY__uswitch = function LEGACY__uswitch(_ref) {
  var heading = _ref.heading,
      img = _ref.hero_image,
      body = _ref.meta_description,
      url = _ref.url;
  return {
    title: heading,
    description: body,
    linkHref: url,
    linkText: 'More info',
    image: img
  };
};

var LEGACY__bankrate = function LEGACY__bankrate(_ref2) {
  var description = _ref2.description,
      metaDescription = _ref2.meta_description,
      date = _ref2.wp_updated_date,
      image = _ref2.hero_image,
      title = _ref2.title,
      url = _ref2.url,
      linkText = _ref2.linkText;
  return {
    title: title,
    image: image,
    linkHref: "/uk/".concat(url),
    description: metaDescription || description,
    linkText: dayjs(date).format('Do MMMM, YYYY')
  };
};
/** --- Legacy end */

/**
 * Page Type mappings are based on the `URL' model in contentful
 * https://github.com/uswitch/contentful-components/tree/master/models/url
 */


var page = function page(_ref3) {
  var pageType = _ref3.pageType,
      props = _objectWithoutProperties(_ref3, _excluded);

  return sw({
    Review: reviewPage,
    default: guidePage
  })(pageType, props);
};

var reviewPage = function reviewPage(_ref4) {
  var showDescription = _ref4.showDescription,
      metaDescription = _ref4.metaDescription,
      showDate = _ref4.showDate,
      dateFormat = _ref4.dateFormat,
      publishedAt = _ref4.publishedAt,
      showLink = _ref4.showLink,
      linkText = _ref4.linkText,
      metaImage = _ref4.metaImage,
      title = _ref4.title,
      url = _ref4.url,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return {
    title: title,
    description: showDescription ? metaDescription : null,
    linkText: showLink ? linkText : null,
    linkHref: url,
    image: metaImage
  };
};

var guidePage = function guidePage(_ref5) {
  var showDescription = _ref5.showDescription,
      metaDescription = _ref5.metaDescription,
      showDate = _ref5.showDate,
      dateFormat = _ref5.dateFormat,
      publishedAt = _ref5.publishedAt,
      showLink = _ref5.showLink,
      linkText = _ref5.linkText,
      metaImage = _ref5.metaImage,
      title = _ref5.title,
      url = _ref5.url,
      props = _objectWithoutProperties(_ref5, _excluded3);

  return {
    title: title,
    description: showDescription ? metaDescription : null,
    linkText: showLink ? linkText : null,
    linkHref: url,
    image: metaImage
  };
};

export var usePageProps = function usePageProps(props) {
  var entityProps = useEntity(props.entity);
  var mappedProps = sw({
    richPage: page,
    modularPage: page,
    guide: LEGACY__uswitch,
    post: LEGACY__bankrate,
    rate_table: LEGACY__bankrate,
    calculator: LEGACY__bankrate,
    default: null
  })(contentTypeId(entityProps), _objectSpread(_objectSpread({}, props), entityProps));
  return {
    entityProps: entityProps,
    mappedProps: mappedProps
  };
};
export var ConnectedGuide = function ConnectedGuide(props) {
  // FIXME: This is an interface touch point between eevee core & old redux state
  var _usePageProps = usePageProps(props),
      entityProps = _usePageProps.entityProps,
      mappedProps = _usePageProps.mappedProps;

  if (props.showSimpleCard) {
    return _jsx(SimpleCategoryGuideCard, _objectSpread(_objectSpread(_objectSpread({}, props), entityProps), mappedProps));
  }

  return _jsx(Card, _objectSpread(_objectSpread(_objectSpread({}, props), entityProps), mappedProps));
};
export default (function (_ref6) {
  var _guide$fields, _guide$fields$variant, _guide$fields2, _guide$fields3, _guideCardMeta$props$;

  var guide = _ref6.guide,
      linkText = _ref6.linkText,
      showDate = _ref6.showDate,
      props = _objectWithoutProperties(_ref6, _excluded4);

  var connectedEntity = guide !== null && guide !== void 0 && (_guide$fields = guide.fields) !== null && _guide$fields !== void 0 && (_guide$fields$variant = _guide$fields.variants) !== null && _guide$fields$variant !== void 0 && _guide$fields$variant.length ? guide === null || guide === void 0 ? void 0 : (_guide$fields2 = guide.fields) === null || _guide$fields2 === void 0 ? void 0 : _guide$fields2.variants[0] : (guide === null || guide === void 0 ? void 0 : (_guide$fields3 = guide.fields) === null || _guide$fields3 === void 0 ? void 0 : _guide$fields3.entry) || guide.fields.link;
  var guideCardMeta = useMeta(['guideCard'], {});
  /**
   * Meta settings to configure card display by brand
   *
   * showDescription - Whether to show the meta description in the card
   * showDateMeta        - Whether to show the published date as superscript
   * showLink        - Whether to show the read more link text
   */

  var _guideCardMeta$guideC = _objectSpread(_objectSpread({}, guideCardMeta), guideCardMeta[props.variant]),
      _guideCardMeta$guideC2 = _guideCardMeta$guideC.linkText,
      linkTextValue = _guideCardMeta$guideC2 === void 0 ? linkText : _guideCardMeta$guideC2,
      _guideCardMeta$guideC3 = _guideCardMeta$guideC.linkIcon,
      linkIcon = _guideCardMeta$guideC3 === void 0 ? null : _guideCardMeta$guideC3,
      _guideCardMeta$guideC4 = _guideCardMeta$guideC.dateFormat,
      dateFormat = _guideCardMeta$guideC4 === void 0 ? 'Do MMMM, YYYY' : _guideCardMeta$guideC4,
      showDescription = _guideCardMeta$guideC.showDescription,
      showDateMeta = _guideCardMeta$guideC.showDate,
      showLink = _guideCardMeta$guideC.showLink;

  var headerIcon = (_guideCardMeta$props$ = guideCardMeta[props.variant]) === null || _guideCardMeta$props$ === void 0 ? void 0 : _guideCardMeta$props$.headerIcon;
  var headerIconSettings = headerIcon ? _jsx(DynamicSparkIcon, {
    glyph: headerIcon.glyph,
    size: headerIcon.size,
    direction: headerIcon.direction
  }) : null;
  return _jsx(ConnectedGuide, _objectSpread({
    customDate: guide.fields.updatedDate || guide.fields.publishDate,
    entity: connectedEntity,
    url: guide.fields.url,
    pageType: guide.fields.pageType,
    linkIcon: linkIcon,
    linkText: linkTextValue,
    dateFormat: dateFormat,
    showDescription: showDescription !== false,
    showDate: showDate,
    showDateInSuperscript: showDateMeta !== false,
    showLink: showLink !== false,
    headerIconSettings: headerIconSettings
  }, props));
});
//# sourceMappingURL=index.js.map